export default __webpack_public_path__ + "static/media/close.36b500fe.svg";